import { Fragment, useContext, useMemo, useState } from "react";

import useSharedData from "../../../../../../hooks/useSharedData";
import FactorContext from "../../context/FactorContext";
import PayLinkModal from "./PayLinkModal";

export default function PayLinkButton({ disabled }) {
  const { factorDetail } = useContext(FactorContext);
  const { isAgent } = useSharedData();
  const [show, setShow] = useState(false);

  const isCod = useMemo(() => {
    try {
      const find = factorDetail.shipments.find(
        element => element.item.isCod === 1
      );
      return find ? true : false;
    } catch (error) {
      return false;
    }
  }, []);

  const sender = useMemo(() => {
    const sender = factorDetail.shipments[0].address.sender;

    const mobile = sender.phone;
    const fullName =
      sender.type === 0 ? `${sender.name} ${sender.family}` : sender.compony;

    const numberParcels = factorDetail.shipments.map(
      element => element.item.numberParcel
    );

    return { mobile, numberParcels, fullName };
  }, []);

  const getters = useMemo(() => {
    const array = [];

    factorDetail.shipments.forEach(element => {
      const find = array.find(
        person => person.mobile === element.geteradress.getter.phone
      );

      if (find) {
        find.numberParcels.push(element.item.numberParcel);
        return;
      }

      array.push({
        mobile: element.geteradress.getter.phone,
        fullName:
          element.geteradress.getter.type === 0
            ? `${element.geteradress.getter.name} ${element.geteradress.getter.family}`
            : element.geteradress.getter.compony,
        numberParcels: [element.item.numberParcel],
      });
    });

    return array;
  }, []);

  if (isCod) {
    return null;
  }

  if (!isAgent) {
    return null;
  }

  return (
    <Fragment>
      <button
        className="buttonUi btn-success-style text-center text-white my-2"
        disabled={disabled}
        onClick={() => setShow(true)}
      >
        <span>ارسال لینک پرداخت</span>
      </button>

      {show && (
        <PayLinkModal
          onClose={() => setShow(false)}
          sender={sender}
          getters={getters}
        />
      )}
    </Fragment>
  );
}
